<template>
	<div class="withdraw-page">
		<!-- 汇总 -->
		<div style="margin: 10px 0">
		截至目前：税前提现总金额 {{ allCount.totalPreTaxAmount }}元，扣税比例{{
			allCount.taxRatePercent
		}}%，税后提现总金额{{ allCount.totalPostTaxAmount }}元
		</div>
		
		<!-- 标签页 -->
		<el-tabs v-model="activeTab" @tab-click="changeSelectValue" type="card" class="tab-box">
			<!-- 提现统计 -->
			<el-tab-pane label="提现统计" name="stat">
				<!-- 查询区域 -->
				<div class="query-row">
					<div class="query-item">
						<span>时间:</span>
						<el-date-picker
								v-model="statQuery.dateRange"
								type="daterange"
								range-separator="-"
								separator="至"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								clearable
								style="width: 280px"
								 :picker-options="pickerOptions"
						/>
					</div>
					<el-button type="primary" @click="getStatListFun">查询</el-button>
				</div>
				
				<!-- 统计表格 -->
				<el-table
						:data="statList"
						border
						stripe
						header-align="center"
						align="center"
						size="medium"
				>
					<el-table-column label="系统日期" prop="dateTime" header-align="center" align="center" ></el-table-column>
					<el-table-column label="税前提现金额(元)" prop="preTaxAmount" header-align="center" align="center" width="">
						<template slot-scope="scope">
							<div class="color-green">{{ scope.row.preTaxAmount }}</div>
						</template>
					</el-table-column>
					<el-table-column label="扣税比例" prop="taxRatePercent" header-align="center" align="center" width="" ></el-table-column>
					<el-table-column label="税后提现金额(元)" prop="postTaxAmount" header-align="center" align="center" width="">
						<template slot-scope="scope">
							<span class="color-green">{{ scope.row.postTaxAmount }}</span>
						</template>
					</el-table-column>
				</el-table>
				
				<!-- 统计分页 -->
				<div class="pager-box">
					<span>共{{ statTotal }}条</span>
					<el-pagination
							:page-sizes="[20, 50, 100]"
							:page-size="statPage.pageSize"
							:current-page="statPage.pageNum"
							:total="statTotal"
							layout="sizes, prev, pager, next, jumper"
							@size-change="statSizeChange"
							@current-change="statPageChange"
					/>
				</div>
			</el-tab-pane>
			
			<!-- 提现明细 -->
			<el-tab-pane label="提现明细" name="detail">
				<!-- 查询区域 -->
				<div class="query-row detail-query">
					<div class="query-item">
						<span>用户姓名:</span>
						<el-input v-model="detailQuery.userName" placeholder="请输入用户姓名" style="width: 160px" ></el-input>
					</div>
					<div class="query-item">
						<span>手机号:</span>
						<el-input v-model="detailQuery.phone" placeholder="请输入手机号" style="width: 160px" ></el-input>
					</div>
					<div class="query-item">
						<span>提现方式:</span>
						<el-select v-model="detailQuery.type" placeholder="请选择" style="width: 120px">
							<el-option label="提成转入" :value="1" ></el-option>
							<el-option label="手动提现" :value="2" ></el-option>
							<el-option label="自动提现" :value="3" ></el-option>
							<el-option label="提现失败退回" :value="4" ></el-option>
							<el-option label="退费回补" :value="5" ></el-option>
						</el-select>
					</div>
					
					<div class="query-item time-box">
						<span>时间:</span>
						<el-button size="mini" @click="setDay(-1)">前一天</el-button>
						<el-date-picker
								v-model="detailQuery.dateRange"
								type="daterange"
								range-separator="-"
								separator="至"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								clearable
								style="width: 280px"
								:picker-options="pickerOptions"
						/>
						<el-button size="mini" @click="setDay(1)">后一天</el-button>
					</div>
					
					<div class="query-item">
						<span>金额范围:</span>
						<el-input v-model="detailQuery.minAmt" placeholder="最小" style="width: 100px" ></el-input>
						<span>-</span>
						<el-input v-model="detailQuery.maxAmt" placeholder="最大" style="width: 100px" ></el-input>
					</div>
					
					<el-button type="primary" @click="resetDetailQuery">重置查询条件</el-button>
					<el-button type="primary" @click="getDetailList">查询</el-button>
				</div>
				
				<!-- 明细表格 -->
				<el-table
						:data="detailList"
						border
						stripe
						header-align="center"
						align="center"
						size="medium"
				>
					<el-table-column label="提现时间" prop="applyTime" header-align="center" align="center"></el-table-column>
					<el-table-column label="税前金额(元)" prop="preTaxAmount" header-align="center" align="center" ></el-table-column>
					<el-table-column label="扣税比例" prop="taxRatePercent" header-align="center" align="center" ></el-table-column>
					<el-table-column label="税后金额(元)" prop="postTaxAmount" header-align="center" align="center" >
						<template slot-scope="scope">
							<div class="color-green">{{ scope.row.postTaxAmount }}</div>
						</template>
					</el-table-column>
					<el-table-column label="提现方式" prop="withdrawType" header-align="center" align="center" >
						<template slot-scope="scope">
							<el-tag type="success" v-if="scope.row.bizType === 1">{{ '提成转入'}}</el-tag>
							<el-tag type="warning" v-else-if="scope.row.bizType === 2">{{ '手动提现'}}</el-tag>
							<el-tag type="info" v-else-if="scope.row.bizType === 3">{{ '自动提现'}}</el-tag>
							<el-tag type="danger" v-else-if="scope.row.bizType === 4">{{ '提现失败退回'}}</el-tag>
							<el-tag type="danger" v-else-if="scope.row.bizType === 5">{{ '退费回补' }}</el-tag>
							<el-tag type="info" v-else>{{ '-' }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="用户名" prop="nickName" header-align="center" align="center" ></el-table-column>
					<el-table-column label="手机" prop="phoneNumber" header-align="center" align="center" ></el-table-column>
					<el-table-column label="转账状态" prop="transferStatus" header-align="center" align="center" ></el-table-column>
					<el-table-column label="失败原因" prop="failReason" header-align="center" align="center" ></el-table-column>
				</el-table>
				
				<!-- 明细分页 -->
				<div class="pager-box">
					<span>共{{ detailTotal }}条</span>
					<el-pagination
							:page-sizes="[20, 50, 100]"
							:page-size="detailPage.pageSize"
							:current-page="detailPage.pageNum"
							:total="detailTotal"
							layout="sizes, prev, pager, next, jumper"
							@size-change="detailSizeChange"
							@current-change="detailPageChange"
					/>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
// 引入后台接口（请根据实际项目的接口路径调整）
import {
	getWebUserQmxfWithdrawRecordsListPageCount,
	getWebUserQmxfWithdrawRecordsListPage,
	getWithdrawSummary
} from "../../api/api";// 假设接口文件在 api/withdraw.js 中
import { useEnterSearch, removeEnterSearch } from '../../../util/enterSearch';
export default {
	name: "WithdrawStatistics",
	data() {
		return {
			// 当前激活标签
			activeTab: "stat",
			// 总条数（初始化为0，从接口获取）
			statTotal: 0,
			detailTotal: 0,
			
			// ============= 提现统计 =============
			statQuery: {
				dateRange: ""
			},
			statPage: {
				pageNum: 1,
				pageSize: 20
			},
			statList: [], // 清空模拟数据，从接口获取
			
			// ============= 提现明细 =============
			detailQuery: {
				userName: "",
				phone: "",
				type: undefined,
				dateRange: "",
				minAmt: "",
				maxAmt: ""
			},
			detailPage: {
				pageNum: 1,
				pageSize: 20
			},
			detailList: [], // 清空模拟数据，从接口获取
			pickerOptions: {
				disabledDate(time) {
					// 禁用今天之后的日期
					return time.getTime() > Date.now();
				}
			},
			allCount:""
		};
	},
		mounted() {
		// 添加全局回车搜索功能
		useEnterSearch(() => {
			if (this.activeTab === "stat") {
				this.getStatList();
			} else if (this.activeTab === "detail") {
				this.getDetailList();
			}
		});
	},
	beforeDestroy() {
		// 移除全局回车监听
		removeEnterSearch();
	},
	methods: {
		getWithdrawSummaryFun(){
			getWithdrawSummary().then(res=>{
				if(res.data.success){
					this.allCount = res.data.response
				}
			})
		},
		// 切换标签页重新加载数据
		changeSelectValue(value) {
			console.log("切换标签页：", value);
			if (value.name === "stat"){
				this.getStatList();
			}else if (value.name === "detail"){
				this.getDetailList();
			}
		},
		getStatListFun(){
			this.statPage.pageNum = 1
			this.getStatList()
		},
		// ========== 提现统计 ==========
		async getStatList() {
			try {
				// 封装查询参数（根据后台接口要求调整字段名）
				const params = {
					pageIndex : this.statPage.pageNum,
					pageSize: this.statPage.pageSize,
					// 处理日期范围：拆分成开始/结束日期
					startTime: this.statQuery.dateRange ? this.statQuery.dateRange[0] : '',
					endTime: this.statQuery.dateRange ? this.statQuery.dateRange[1] : ''
				};
				
				// 调用统计接口（若统计有独立接口，替换为实际统计接口；若复用明细接口，需调整）
				// 注：若统计接口未提供，可基于明细接口聚合，此处先假设复用明细分页接口逻辑
				const res = await getWebUserQmxfWithdrawRecordsListPageCount(params);
				
				if (res.data.success ) { // 假设接口返回code=200为成功
					this.statList = res.data.response.data;
					this.statTotal = res.data.response.dataCount;
					// this.$message.success("提现统计查询成功");
				} else {
					this.$message.error(res.data.message || "提现统计查询失败");
				}
			} catch (error) {
				console.error("提现统计查询异常：", error);
				this.$message.error("网络异常，提现统计查询失败");
			}
			
		},
		statSizeChange(val) {
			this.statPage.pageSize = val;
			this.getStatList(); // 分页大小变化时重新查询
		},
		statPageChange(val) {
			this.statPage.pageNum = val;
			this.getStatList(); // 页码变化时重新查询
		},
		
		// ========== 提现明细 ==========
		// 前一天 / 后一天
		setDay(num) {
			const date = new Date();
			date.setDate(date.getDate() + num);
			const y = date.getFullYear();
			const m = (date.getMonth() + 1).toString().padStart(2, "0");
			const d = date.getDate().toString().padStart(2, "0");
			const dayStr = `${y}-${m}-${d}`;
			this.detailQuery.dateRange = [dayStr, dayStr];
		},
		// 重置查询
		resetDetailQuery() {
			this.detailQuery = {
				userName: "",
				phone: "",
				type: undefined,
				dateRange: "",
				minAmt: "",
				maxAmt: ""
			};
		},
		// 查询明细（核心：调用后台接口）
		async getDetailList() {
			try {
				// 1. 封装查询参数（适配后台接口字段要求）
				const params = {
					// 分页参数
					pageIndex : this.detailPage.pageNum,
					pageSize: this.detailPage.pageSize,
					// 基础查询条件
					nickName: this.detailQuery.userName.trim() || '',
					phoneNumber: this.detailQuery.phone.trim() || '',
					bizType: this.detailQuery.type === 'all' ? '' : this.detailQuery.type,
					// 日期范围
					startTime: this.detailQuery.dateRange ? this.detailQuery.dateRange[0] : '',
					endTime: this.detailQuery.dateRange ? this.detailQuery.dateRange[1] : '',
					// 金额范围
					startAmount: this.detailQuery.minAmt ? Number(this.detailQuery.minAmt) : '',
					endAmount: this.detailQuery.maxAmt ? Number(this.detailQuery.maxAmt) : ''
				};
				
				// 2. 先查总数（可选：若分页接口已返回total，可省略此步）
				// const countRes = await getWebUserQmxfWithdrawRecordsListPageCount(params);
				// if (countRes.code !== 200) throw new Error(countRes.msg || '获取总数失败');
				// this.detailTotal = countRes.data;
				
				// 3. 查分页列表
				const listRes = await getWebUserQmxfWithdrawRecordsListPage(params);
				if (listRes.data.success) {
					this.detailList = listRes.data.response.data; // 假设接口返回 { list: [], total: 0 }
					this.detailTotal = listRes.data.response.dataCount;
					// this.$message.success("提现明细查询成功");
				} else {
					this.$message.error(listRes.data.message || "提现明细查询失败");
				}
			} catch (error) {
				console.error("提现明细查询异常：", error);
				this.$message.error("网络异常，提现明细查询失败");
			}
			
		},
		detailSizeChange(val) {
			this.detailPage.pageSize = val;
			this.getDetailList(); // 分页大小变化重新查询
		},
		detailPageChange(val) {
			this.detailPage.pageNum = val;
			this.getDetailList(); // 页码变化重新查询
		}
	},
	created() {
		this.getStatList();
		this.getWithdrawSummaryFun();
	}
};
</script>

<style scoped>
.withdraw-page {
	width: 98%;
	margin: 20px auto;
	padding: 20px;
	background: #fff;
	box-sizing: border-box;
}

.top-total {
	font-size: 14px;
	color: #333;
	margin-bottom: 15px;
}

.tab-box {
	margin-top: 5px;
}

.query-row {
	display: flex;
	align-items: center;
	gap: 12px;
	margin-bottom: 15px;
	flex-wrap: wrap;
}

.detail-query {
	padding: 10px;
	background: #f9f9f9;
	border-radius: 4px;
}

.query-item {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 14px;
	color: #666;
}

.time-box {
	gap: 8px;
}

.pager-box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 18px;
	font-size: 14px;
	color: #666;
}

/* 金额绿色高亮 */
.color-green {
	color: #00b42a;
	font-weight: 500;
	padding: 5px 10px;
}
</style>